import type { TemplateFieldTypesFetchedAction } from '@Application/Documents/TemplateFieldTypes/Actions/templateFieldTypesFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type TemplateFieldTypesStore = {
	templateFieldTypes: readonly LabeledValueView[] | null;
};

const initialState: TemplateFieldTypesStore = {
	templateFieldTypes: null,
};

type Actions = TemplateFieldTypesFetchedAction | UserRevokedAction;

const whenTemplateFieldTypesFetched = (
	store: TemplateFieldTypesStore,
	action: TemplateFieldTypesFetchedAction,
): TemplateFieldTypesStore => ({
	...store,
	templateFieldTypes: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): TemplateFieldTypesStore => initialState;

export default registerStore<'templateFieldTypesStore', Actions>(
	'templateFieldTypesStore',
	createSliceReducer({
		TEMPLATE_FIELD_TYPES_FETCHED: whenTemplateFieldTypesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
